
interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const femalepackage: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "female-fertility-package",
        "meta": {
            "title": "Female Fertility Package Dubai | Elite Body Home",
            "description": "Comprehensive fertility assessment and treatment package for women trying to conceive. Includes hormonal testing, ovulation monitoring, and personalized fertility plans.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/female-fertility-package/",
            "og": {
                "title": "Female Fertility Package Dubai | Elite Body Home",
                "description": "Holistic fertility assessment and treatment to support your journey to conception",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Female Fertility Package"],
        "hero": {
            "title": "Female Fertility Package Dubai",
            "subtitle": "Supporting Your Journey to Motherhood",
            "description": "At Elite Body Home Polyclinic we know that having or growing a family is an important decision in life. The female fertility package is intended to provide holistic care by targeting different areas of fertility to improve your chances of getting pregnant. Targeted at all women wanting to conceive or those previously unable to become pregnant, this package centres around advanced diagnostics, tailored treatment plans and the right specialist assistance."
        },
        "howItWorks": {
            "title": "What Our Female Fertility Package Includes",
            "description": "This fertility package covers the full range of initial fertility assessments to ongoing monitoring so that women can understand their reproductive health and take proactive steps toward a healthy pregnancy."
        },
        "procedureSteps": {
            "heading": "Procedure",
            "para": "The process of assessing your fertility, as well as determining the best treatment, is truly stepwise and patient-specific. Our package involves comprehensive consultations and diagnostic procedures to ensure we identify any issues underlying your fertility and plan the best route to conception.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "An in-depth consultation with a fertility specialist to discuss your medical history, lifestyle, and previous attempts at conceiving.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Physical Examination",
                    "desc": "Broad reproductive health screening to detect problems.",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "Hormonal Profile Testing",
                    "desc": "Testing hormone levels: Blood tests to measure important fertility hormones such as FSH, LH, and AMH.",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "Ovulation Testing",
                    "desc": "Tracking and testing to show normal ovulation.",
                    "icon": "fa-solid fa-egg"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "",
            "para": "The female Fertility Package is a comprehensive plan that includes a series of benefits designed to increase the chances of successful conception, along with medical and emotional support during the process.",
            "items": [
                {
                    "title": "Comprehensive Assessment",
                    "desc": "A complete reproductive health assessment assists in the early identification of fertility problems.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Tailored Treatments",
                    "desc": "Individual test results are the foundation of personalized fertility plans, increasing the chances of success.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "Expert Support",
                    "desc": "Experienced fertility specialists who help you through every step of your experience.",
                    "icon": "fa-solid fa-hands-helping"
                },
                {
                    "title": "Advanced Diagnostics",
                    "desc": "We have access to the latest in testing and monitoring technologies, ensuring accuracy and effectiveness.",
                    "icon": "fa-solid fa-microscope"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "Fertility Package for Females is for a woman wanting to check or improve their chances of conceiving. It is suitable for:",
            "items": [
                {
                    "title": "Women Under 35",
                    "desc": "Women aged less than 35 years having pregnancy difficulties for more than 12 months.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Women Over 35",
                    "desc": "For example, women over 35 who have been trying to get pregnant for 6 months.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "Known Fertility Issues",
                    "desc": "Women with known fertility related issues PCOS, Endometriosis or irregular cycles.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "Preconception Planning",
                    "desc": "Women with plans to become pregnant in the next few years, and interested in optimizing preconception health.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "How to Prepare for the Fertility Assessment? Here's what you need to do:",
            "items": [
                {
                    "title": "Medical Records",
                    "desc": "Collect and bring any relevant medical history specific to reproductive health, such as past fertility treatments or test results.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "Track Menstrual Cycle",
                    "desc": "It can be helpful to track your cycle for three or more months in advance of the consultation in order to offer insights into patterns in ovulation and menstruation.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Healthy Lifestyle",
                    "desc": "Eating a well balanced diet, maintaining a healthy body weight and cutting down on alcohol and caffeine may also help fertility.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "The Female Fertility Package Provides clear insight into your reproductive health and an actionable plan to help you conceive. Through testing and individualized care, a large number of women undergo successful pregnancies after treatment for fertility.",
            "items": [
                {
                    "title": "Increased Pregnancy Rates",
                    "desc": "Timely diagnosis and timely intervention are immensely likely to improve the prospects of conception.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Improved Reproductive Health",
                    "desc": "By identifying lifestyle and medical factors that affect fertility, you will improve your general reproductive health.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Peace of Mind",
                    "desc": "Understanding your fertility status enables better family planning choices.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Why Elite Body Home for Female Fertility Package?",
            "subheading": "",
            "para": "We offer expert fertility care at Elite Body Home, customized according to your wishes. A comprehensive evaluation using advanced diagnostic tools, including hormone testing, ultrasounds, and genetic screening, is performed by our dedicated experts in fertility. We create tailored treatment approaches, where every phase of your fertility journey is handled under the care of advanced technology and constant assistance.",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does the fertility assessment take?",
                    "answer": "The initial consultation and diagnostic tests typically take 2–4 weeks to complete. Depending on your cycle, additional monitoring may be needed."
                },
                {
                    "question": "Will I need IVF if I have fertility issues?",
                    "answer": "Not necessarily. Treatment plans are highly personalized and may include less invasive options like ovulation induction or IUI before considering IVF."
                },
                {
                    "question": "Are the tests in the fertility package painful?",
                    "answer": "Most tests, such as blood work and ultrasounds, are non-invasive and cause minimal discomfort. The HSG test may cause mild cramping, similar to period pains."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Female-Fertility-Package-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 14,
            "title": "Female Fertility Package in Dubai",
            "description": "Comprehensive fertility assessment and treatment to support your journey to conception",
            "price": 1200
        }
    },
    "ar": {
        "url": "female-fertility-package",
        "meta": {
            "title": "باقة فحص الخصوبة للنساء في دبي | ايليت بودي هوم",
            "description": "باقة شاملة لتقييم وعلاج الخصوبة للنساء اللواتي يحاولن الحمل. تشمل اختبارات هرمونية، متابعة التبويض، وخطط خصوبة مخصصة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/female-fertility-package",
            "og": {
                "title": "باقة فحص الخصوبة للنساء في دبي | ايليت بودي هوم",
                "description": "تقييم وعلاج شامل للخصوبة لدعم رحلتك نحو الحمل",
                "image": "https://www.elitebodyhome.com/images/female-fertility-package-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "باقة فحص الخصوبة للنساء"],
        "hero": {
            "title": "باقة فحص الخصوبة للنساء في دبي",
            "subtitle": "ندعمك في رحلتك نحو الأمومة",
            "description": "ندرك في عيادات ايليت بودي هوم أن بدء في إنشاء أسرة خطوة مهمة في حياة كل امرأة. صُممت باقة فحص الخصوبة للنساء لتقديم رعاية شاملة تتضمن جميع جوانب الخصوبة، بما يعزز فرص الحمل ويمنحك راحة البال خلال هذه المرحلة الحساسة. تجمع هذه الباقة بين أحدث وسائل التشخيص وفحص خصوبة المرأة وخطط العلاج المخصصة والدعم الطبي المتكامل، وهي مثالية للنساء اللواتي يخططن للحمل أو يواجهن صعوبة في الإنجاب."
        },
        "howItWorks": {
            "title": "ما الذي تتضمنه باقة فحص الخصوبة للنساء؟",
            "description": "تشمل الباقة كل ما تحتاجينه من تقييم أولي للخصوبة وحتى المتابعة الدورية، مما يساعدك على فهم صحتك الإنجابية واتخاذ خطوات فعالة نحو حمل صحي وسليم."
        },
        "procedureSteps": {
            "heading": "الإجراء",
            "para": "تمر رحلة تقييم الخصوبة وفحص صحة المرأة في ايليت بودي هوم بعدة مراحل دقيقة، مصممة خصيصًا لتلبية احتياجات كل سيدة على حدة. تشمل باقتنا فحوصات دقيقة وإجراءات متخصصة تهدف إلى الكشف عن أي مشكلات خفية قد تؤثر على الخصوبة، وذلك من أجل وضع خطة علاجية مثالية تُعزز فرص الحمل بنجاح.",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "تتم مقابلة شاملة مع أخصائي الخصوبة لمراجعة التاريخ الطبي، ونمط الحياة، ومحاولات الحمل السابقة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "الفحص البدني",
                    "desc": "تقييم الحالة العامة للصحة الإنجابية، وتشخيص أي مؤشرات لمشكلات تؤثر على الخصوبة.",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "فحوصات الهرمونات",
                    "desc": "تُجرى فحوصات الدم لقياس مستويات الهرمونات الأساسية مثل الهرمون المنبه للجريب (FSH)، والهرمون اللوتيني (LH)، ومخزون المبيض (AMH).",
                    "icon": "fa-solid fa-vial"
                },
                {
                    "title": "اختبار التبويض",
                    "desc": "يتابع التبويض بشكل دقيق للتأكد من انتظامه وجودته.",
                    "icon": "fa-solid fa-egg"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "توفر باقة فحص الخصوبة مجموعة متكاملة من الفوائد الطبية والنفسية، بهدف تعزيز فرص الحمل ومرافقتك في كل خطوة في رحلتك نحو الأمومة.",
            "items": [
                {
                    "title": "تقييم شامل",
                    "desc": "يساعد الفحص المتكامل للحالة الصحية الإنجابية على الكشف المبكر عن أي مشكلات تؤثر على الخصوبة.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "خطط علاجية مخصصة",
                    "desc": "تُصمم خطط علاجية فردية بناءً على نتائج التحاليل والفحوصات لضمان أعلى فرص النجاح.",
                    "icon": "fa-solid fa-user-md"
                },
                {
                    "title": "إشراف نخبة من الخبراء",
                    "desc": "تتم متابعة دقيقة من قبل أطباء وأخصائيي خصوبة ذوي خبرة عالية يقدمون لك التوجيه والدعم في كل مرحلة.",
                    "icon": "fa-solid fa-hands-helping"
                },
                {
                    "title": "تقنيات متقدمة للتشخيص",
                    "desc": "نعتمد على أحدث تقنيات الفحص والمتابعة لضمان دقة النتائج وفاعلية الخطط العلاجية.",
                    "icon": "fa-solid fa-microscope"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "صُممت باقة الخصوبة في ايليت بودي هوم خصيصًا للنساء الراغبات في تقييم وتحسين فرص الحمل لديهن، وتشمل الفئات المناسبة:",
            "items": [
                {
                    "title": "النساء تحت سن 35 عامًا",
                    "desc": "النساء تحت سن 35 عامًا اللواتي يحاولن الحمل منذ أكثر من 12 شهرًا.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "النساء فوق سن 35 عامًا",
                    "desc": "النساء فوق سن 35 عامًا اللواتي يحاولن الحمل منذ 6 أشهر.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "مشكلات الخصوبة المعروفة",
                    "desc": "النساء اللواتي يعانين من مشكلات في الصحة الإنجابية مثل متلازمة تكيس المبايض (PCOS)، أو بطانة الرحم المهاجرة، أو اضطرابات الدورة الشهرية.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "التخطيط المسبق للحمل",
                    "desc": "النساء اللواتي يخططن للحمل قريبًا ويرغبن في تقييم وتحسين صحتهن الإنجابية مسبقًا.",
                    "icon": "fa-solid fa-baby"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يُعد التحضير خطوة أساسية لضمان دقة النتائج وفاعلية خطة العلاج. إليك ما يجب القيام به قبل الموعد:",
            "items": [
                {
                    "title": "السجلات الطبية",
                    "desc": "أحضري معك جميع السجلات الطبية السابقة المتعلقة بالصحة الإنجابية، بما في ذلك نتائج الفحوصات أو العلاج السابق الخاص بالخصوبة.",
                    "icon": "fa-solid fa-folder-open"
                },
                {
                    "title": "تتبع الدورة الشهرية",
                    "desc": "يُفضل تتبع دورتك الشهرية لمدة لا تقل عن بضعة أشهر قبل الاستشارة، لتقديم معلومات دقيقة عن التبويض وانتظام الدورة.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "اتباع نمط حياة صحي",
                    "desc": "يمكن ان يساعد اتباع نظام غذائي متوازن، والحفاظ على وزن صحي، وتقليل الكافيين والكحول على تحسين الخصوبة بشكل كبير.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "توفر باقة الخصوبة للنساء رؤى واضحة حول صحتك الإنجابية، إلى جانب خطة علاجية قابلة للتنفيذ تساعدك في تحقيق حلم الإنجاب. من خلال الفحوصات الدقيقة والرعاية الشخصية، تمكنت العديد من النساء من الحمل بنجاح بعد الخضوع لهذا التقييم.",
            "items": [
                {
                    "title": "زيادة فرص الحمل",
                    "desc": "يؤدي التشخيص المبكر والتدخل في الوقت المناسب إلى رفع احتمالية حدوث الحمل بشكل ملحوظ.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "تحسين الصحة الإنجابية",
                    "desc": "ستتمكنين من تعزيز صحتك الإنجابية بشكل عام من خلال معالجة العوامل الطبية ونمط الحياة المؤثر على الخصوبة.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "راحة البال",
                    "desc": "يمنحك معرفة وضعك الإنجابي بدقة القدرة على اتخاذ قرارات مستنيرة بشأن تخطيط الأسرة بثقة ووضوح.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا يجب اختيار عيادات ايليت بودي هوم؟",
            "subheading": "",
            "para": "خبرة تمتد لأكثر من 25 عامًا فريق طبي مؤهل نتائج تركز على احتياجات العميل",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق عملية تقييم الخصوبة؟",
                    "answer": "عادة ما تستغرق الاستشارة الأولية والفحوصات التشخيصية من 2 إلى 4 أسابيع. قد تحتاجين إلى متابعة إضافية حسب دورتك الشهرية."
                },
                {
                    "question": "هل سأحتاج إلى أطفال الأنابيب إذا كانت لدي مشاكل في الخصوبة؟",
                    "answer": "ليس بالضرورة. يتم تصميم خطط العلاج بشكل شخصي وقد تشمل خيارات أقل تدخلاً مثل تحفيز التبويض أو التلقيح داخل الرحم قبل التفكير في أطفال الأنابيب."
                },
                {
                    "question": "هل الفحوصات في باقة الخصوبة مؤلمة؟",
                    "answer": "معظم الفحوصات مثل تحاليل الدم والموجات فوق الصوتية غير جراحية وتسبب الحد الأدنى من الانزعاج. قد يسبب فحص الأشعة للرحم والأنابيب بعض التقلصات الخفيفة تشبه آلام الدورة الشهرية."
                }
            ]
        }
    }
}